export class ErrorDetails {
    
    timestamp: Date;
    
    message: string;

    details: string;

    parameters: string[];

    constructor(timestamp: Date, message: string, details: string, parameters: string[]) {
        this.timestamp = timestamp;
        this.message = message;
        this.details = details;
        this.parameters = parameters;
    }
}
